import React from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import { AnchorSection } from 'react-anchor-navigation';
import './PageIntegration.scss';
import Title from '../../components/Title/Title';
import BlockPersonalSpace from '../../components/BlockPersonalSpace/BlockPersonalSpace';
import Content from '../../components/Content/Content';
import { ListApi, ListFeatures, ListPartners } from './constants';
import CardCount from '../../components/CardCount/CardCount';
import Button from '../../components/Button/Button';
import DescriptionBlock from '../../components/DescriptionBlock/DescriptionBlock';
import BlockIntegration from '../../components/BlockIntegration/BlockIntegration';
import SliderLogos from '../../components/SliderLogos/SliderLogos';
import './PageIntegration-media.scss';
import { MediaContent } from '../../services/GlobalFunctions';
import { Props } from './interfaces';
import {content} from '../../services/content';
const blockIntegration = content.blockIntegration;

const PageIntegration = ({ widthWindow }: Props) => {
  const Bg8 = MediaContent(<div className="page-integration__bg-8"></div>, null);

  return (
    <div className="page-integration">

      <Content
        heightLazy={widthWindow > 720 ? 120 : null}
        block={
          <>
            <Title h1 title="Интеграция за 1 день,<br/>удобный личный кабинет" gradient center />
            <div className="page-integration__bg-6"></div>
          </>
        }
      />

      <Content
        heightLazy={widthWindow > 720 ? 886 : null}
        padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 40, bottom: 40 } }}
        block={<BlockIntegration logosApi={blockIntegration.logos.apiIntegration} />}
      />

      <AnchorSection id="dalli_api">
        <Content
          heightLazy={widthWindow > 720 ? 676 : null}
          padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 36, bottom: 40 } }}
          block={
            <>
              <div className="page-integration__title-block">
                <h2>API Dalli</h2>
                <span></span>
                <Button
                  text="Документация по API"
                  link="https://api.dalli-service.com/v1/doc/"
                  linkOut
                  size="M"
                  type={widthWindow > 720 ? 'black' : 'border'}
                />
              </div>
              <DescriptionBlock
                bg
                text="Мы делаем наше сотрудничество максимально удобным для вас. Представляем вам web-решение, которое сделает сайт вашего интернет-магазина функциональнее, а взаимодействие со службой доставки — быстрым и эффективным."
              />
              {Bg8}
              <div className="page-integration__bg-9"></div>
              <div className="page-integration__grid-4">
                {ListApi.map((item, i) => (
                  <CardCount
                    idx={i + 1}
                    numberCard={i + 1}
                    text={item}
                    bg
                    noCut
                    height={widthWindow > 720 ? 'auto' : 'auto'}
                    key={i}
                  />
                ))}
              </div>
            </>
          }
        />
      </AnchorSection>

      {ListPartners.map(
        (
          {
            hashId,
            title,
            logo,
            heightLogo,
            button,
            buttonLink,
            linkOut = false,
            description,
            list,
            heightLazy,
          },
          i
        ) => (
          <AnchorSection id={hashId} key={i}>
            <Content
              heightLazy={widthWindow > 720 ? heightLazy : null}
              padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 40, bottom: 40 } }}
              block={
                <>
                  <div className="page-integration__title-block">
                    <h2>{title}</h2>
                    {logo ? (
                      <img
                        src={logo}
                        style={{
                          height:
                            widthWindow > 720 && widthWindow < 1440 ? `${heightLogo / 14.4}vw` : heightLogo,
                        }}
                        className="page-integration__logo-partner"
                        alt=""
                      />
                    ) : (
                      <span></span>
                    )}
                    <Button
                      text={button}
                      link={buttonLink}
                      linkOut={linkOut}
                      size="M"
                      type={widthWindow > 720 ? 'black' : 'border'}
                    />
                  </div>
                  <DescriptionBlock bg text={description} />
                  {Bg8}
                  <div className="page-integration__bg-9"></div>
                  <div className="page-integration__grid-3">
                    {list.map((item, i) => (
                      <CardCount
                        idx={i + 1}
                        numberCard={i + 1}
                        text={item}
                        bg
                        noCut
                        height={'auto'}
                        key={i}
                      />
                    ))}
                  </div>
                </>
              }
            />
          </AnchorSection>
        )
      )}

      <Content
        padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 40, bottom: 40 } }}
        block={
          <BlockPersonalSpace
            content={
              <>
                <h2>Личный кабинет клиента</h2>
                <p className="body1">
                  Доступ в личный кабинет предоставляется после заключения договора, так же вы можете
                  запросить тестовый доступ для ознакомления с ЛК. По вопросам использования личного кабинета
                  обращайтесь по телефону +7 (499) 460-90-02 доб. 100, с удовольствием поможем вам.
                </p>
              </>
            }
          />
        }
      />

      <Content
        padding={{ paddingMain: { top: 80, bottom: 80 }, paddingMob: { top: 40, bottom: 40 } }}
        block={
          <>
            <Title title="Возможности личного кабинета" center />
            <div className="page-integration__bg-1"></div>
            <div className="page-integration__grid-4-60">
              {ListFeatures.map((item, i) => (
                <CardCount
                  idx={i + 1}
                  numberCard={i + 1}
                  text={item}
                  bg
                  noCut
                  height={widthWindow > 720 ? 'auto' : 'auto'}
                  key={i}
                />
              ))}
            </div>
          </>
        }
      />

      <Content
        block={
          <div className="page-integration__clients">
            <Title title="Наши клиенты" center />
            <SliderLogos padding="0" />
          </div>
        }
      />
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(PageIntegration));
